import * as React from "react";
import { connect } from "react-redux";
import { Button } from "semantic-ui-react";

import { authorize } from "reauthorize";

import { ThunkDispatch } from "redux-thunk";

import { AppState } from "../../model";
import { activateCustomerUser } from "../../actions";
import { CUSTOMER_ROLES } from "../../../../auth/model";

interface MergedProps {
    activate: () => void;
}

class ActivateButton extends React.Component<MergedProps> {
    public render() {
        return <Button className="positive ui button" content="Activate" floated="left" onClick={() => this.props.activate()} />;
    }
}

interface StateProps {
    id: string;
}

interface DispatchProps {
    dispatchActivate: (id: string) => void;
}

function mapStateToProps(state: AppState): StateProps {
    return {
        id: state.router.params.customerUserId
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<AppState, undefined, any>): DispatchProps {
    return {
        dispatchActivate: (id) => dispatch(activateCustomerUser(id))
    };
}

function mergeProps(propsFromState: StateProps, propsFromDispatch: DispatchProps): MergedProps {
    return {
        activate: () => propsFromDispatch.dispatchActivate(propsFromState.id)
    };
}

export default authorize([CUSTOMER_ROLES.customerAdministrator.name])
(connect(mapStateToProps, mapDispatchToProps, mergeProps)(ActivateButton));
